export default __webpack_public_path__ + "static/media/mail-anim-dark.aef0d81e.svg";